import { acneSuccessStoriesImages } from "./images"

export * from "./churn-prevention-success-stories.dialog"
export const churnPreventionSuccessStoriesPatientIds = Object.keys(
  acneSuccessStoriesImages
)
